module.exports = __webpack_public_path__ + "img/1.ee0555fe.jpg";